import { render, staticRenderFns } from "./TaskBatchCreate.vue?vue&type=template&id=571881ae&scoped=true"
import script from "./TaskBatchCreate.vue?vue&type=script&lang=ts"
export * from "./TaskBatchCreate.vue?vue&type=script&lang=ts"
import style0 from "./TaskBatchCreate.vue?vue&type=style&index=0&id=571881ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571881ae",
  null
  
)

export default component.exports